import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { TypeMetricAssignedTo } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

const selectedMetrics = ref<any[]>([])
const customMetricFormDialog = ref(false)

function addMetricAssignmentsFromTemplate(items: any) {
  customMetricFormDialog.value = true
  selectedMetrics.value = items
}

return { __sfc: true,selectedMetrics, customMetricFormDialog, addMetricAssignmentsFromTemplate, TypeMetricAssignedTo }
}

})